<app-loader [Parent]="this"></app-loader>
@if (FormLoaded) {
  <div [formGroup]="Form">
    <app-pageheader [Parent]="this">
      <app-form-save-button [Parent]="this" [Form]="Form" class="button is-primary" (OnSave)="Save()">
      </app-form-save-button>
    </app-pageheader>
    <div class="columns">
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">{{Model.Name}}</p>
          <div class="panel-block">
            <div class="three-quarters-width">
              <app-field Label="Name" class="control">
                <input formControlName="Name" class="input mb-3" type="text"/>
                <app-validator [For]="this.Form.get('Name')"></app-validator>
              </app-field>
              <app-field Label="Target Type" class="control mb-3">
                <span class="select is-fullwidth">
                  <select formControlName="TargetType" (change)="onTargetTypeSelect($event)">
                    @for (item of ModelTypes; track item) {
                      <option value="{{item.Name}}">{{item.Name}}</option>
                    }
                  </select>
                </span>
              </app-field>
            </div>
          </div>
        </article>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12">
        <article class="panel">
          <p class="panel-heading">Display Rules</p>
          <div class="panel-block">
            <div class="rule-container">
              @for (line of FormArray(Form, 'DisplayRules').controls; track line; let i = $index) {
                <div [@move]="animationStates[i]" (@move.done)="TriggerSwap(i, $event)" [@.disabled]="!UseAnimation" formArrayName="DisplayRules" @fadeInOut>
                  <div [formGroupName]="i" class="rule">
                    <div class="first-rule-cell">
                      <span [ngClass]="line.get('DisplayIndex')?.value == 1 ? 'hide' : 'show'" (click)="moveUp(i)" class="fa fa-chevron-up"></span>
                      <span [ngClass]="line.get('DisplayIndex')?.value < this.Form.get('DisplayRules')?.value.length ? 'show' : 'hide'" (click)="moveDown(i)" class="fa fa-chevron-down"></span>
                    </div>
                    <div class="rule-cell">
                      <label class="label">Conditions</label>
                      @if (line.get('ConditionGroup')?.value?.Conditions?.length > 2) {
                        <span>{{line.get('ConditionGroup')?.value?.Conditions?.length}} conditions</span>
                      }
                      @if (line.get('ConditionGroup')?.value?.Conditions?.length <= 2) {
                        @for (condition of line.get('ConditionGroup')?.value?.Conditions; track condition; let last = $last) {
                          @if (condition.ClassName === 'SignConfigurationDisplayRuleThresholdCondition') {
                            <span>
                              {{condition.TargetThresholdProperty}} {{condition.TargetThresholdOperator}} {{condition.Value}}
                            </span>
                          }
                          @if (condition.ClassName === 'SignConfigurationDisplayRuleTimeCondition') {
                            <span>
                              Time {{condition.Operator}} {{condition.Time}}
                            </span>
                          }
                          @if (condition.ClassName === 'SignConfigurationDisplayRuleDayOfWeekCondition') {
                            <span>
                              Active on: {{getActiveDays(condition)}}
                            </span>
                          }
                          @if (!last) {
                            <span> | </span>
                          }
                        }
                        @if (line.get('ConditionGroup')?.value?.ChildGroups?.length > 0) {
                          <span>{{line.get('ConditionGroup')?.value?.ChildGroups?.length}} Child Groups</span>
                        }
                      }
                    </div>
                    <div class="rule-cell">
                      <label class="label">Mode</label>
                      <span>{{line.get('Mode')?.value == 1 ? 'Single Display' : 'Dual Display'}}</span>
                      @if (line.get('Mode')?.value == 2) {
                        <span>({{line.get('SplitMode')?.value == 0 ? 'Toggle' : (line.get('SplitMode')?.value == 1 ? 'Horizontal Split' : 'Vertical Split')}})</span>
                      }
                    </div>
                    <div class="rule-cell">
                      <label class="label">Content</label>
                      @if (line.get('DataType')?.value > 2) {
                        <span [ngClass]="GetContentIcon(line.get('DataType')?.value)"></span>
                      }
                      @if (line.get('DataType')?.value <= 2) {
                        <span>{{line.get('Content')?.value}}</span>
                      }
                      @if (line.get('Mode')?.value == 2) {
                        <span>|</span>
                      }
                      @if (line.get('Mode')?.value == 2 && line.get('SecondDisplayDataType')?.value <= 2) {
                        <span>{{line.get('SecondDisplayContent')?.value}}</span>
                      }
                      @if (line.get('Mode')?.value == 2 && line.get('SecondDisplayDataType')?.value > 2) {
                        <span [ngClass]="GetContentIcon(line.get('SecondDisplayDataType')?.value)"></span>
                      }
                    </div>
                    <div class="last-rule-cell">
                      <button type="button" (click)="EditDisplayRule(i)" class="button is-small">
                        <i class="fa fa-pencil"></i>
                      </button>
                      <button type="button" (click)="RemoveDisplayRule(i)" class="button is-danger is-small ng-star-inserted  level-item">
                        <i class="fa fa-trash"></i>
                      </button>
                    </div>
                  </div>
                </div>
              }
              <div>
                <button class="button is-primary" (click)="AddDisplayRule()">Add New</button>
              </div>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
}